import { defineStore, acceptHMRUpdate } from 'pinia'
import { STORAGE_KEYS, useCache } from '@/libs/utils/constants'
const { wsCache } = useCache('sessionStorage')
import { getSimpleDictDataList, getAreaTree } from '@/api/dict'
import { getPaymentMethodList } from '@/api/manage/paymentMethod'
export type DictTypeVO = {
  id: number | undefined
  name: string
  type: string
  status: number
  remark: string
  createTime: Date
}

export interface DictState {
  dictMap: Map<string, any>
  isSetDict: boolean
  paymentMethodLabels: Record<string, string>
}

export const useDictStore = defineStore({
  id: STORAGE_KEYS.DICT_DATA,
  state: (): DictState => ({
    dictMap: new Map<string, any>(),
    isSetDict: false,
    paymentMethodLabels: {},
    areaTree: [],
  }),
  getters: {
    getDictMap(): Recordable {
      const dictMap = wsCache.get(STORAGE_KEYS.DICT_DATA)
      if (dictMap) {
        this.dictMap = dictMap
      }
      return this.dictMap
    },
    getIsSetDict(): boolean {
      return this.isSetDict
    },
    getAreaTree(): boolean {
      return this.areaTree
    },
  },
  actions: {
    async setDictMap() {
      const dictMap = wsCache.get(STORAGE_KEYS.DICT_DATA)
      if (dictMap) {
        this.dictMap = dictMap
        this.isSetDict = true
        await this.refreshPaymentMethods()
      } else {
        const res = await getSimpleDictDataList()
        console.log(res)
        // 设置数据
        const dictDataMap = new Map<string, any>()
        res?.data.forEach((dictData: DictDataVO) => {
          // 获得 dictType 层级
          const enumValueObj = dictDataMap[dictData.dictType]
          if (!enumValueObj) {
            dictDataMap[dictData.dictType] = []
          }
          // 处理 dictValue 层级
          dictDataMap[dictData.dictType].push({
            value: dictData.value,
            label: dictData.label,
            colorType: dictData.colorType,
            cssClass: dictData.cssClass,
          })
        })
        this.dictMap = dictDataMap
        this.isSetDict = true
        wsCache.set(STORAGE_KEYS.DICT_DATA, dictDataMap, { exp: 60 }) // 60 秒 过期
        await this.refreshPaymentMethods()
      }
    },
    getDictByType(type: string) {
      if (!this.isSetDict) {
        this.setDictMap()
      }
      return this.dictMap[type]
    },
    getPaymentMethodLabel(code: string) {
      return this.paymentMethodLabels[code]
    },
    async resetDict() {
      wsCache.delete(STORAGE_KEYS.DICT_DATA)
      const res = await getSimpleDictDataList()
      // 设置数据
      const dictDataMap = new Map<string, any>()
      res.forEach((dictData: DictDataVO) => {
        // 获得 dictType 层级
        const enumValueObj = dictDataMap[dictData.dictType]
        if (!enumValueObj) {
          dictDataMap[dictData.dictType] = []
        }
        // 处理 dictValue 层级
        dictDataMap[dictData.dictType].push({
          value: dictData.value,
          label: dictData.label,
          colorType: dictData.colorType,
          cssClass: dictData.cssClass,
        })
      })
      this.dictMap = dictDataMap
      this.isSetDict = true
      wsCache.set(STORAGE_KEYS.DICT_DATA, dictDataMap, { exp: 60 }) // 60 秒 过期
      await this.refreshPaymentMethods()
    },
    async refreshPaymentMethods() {
      try {
        const res = await getPaymentMethodList(false)
        if (res?.code !== 0) return
        this.paymentMethodLabels = Object.fromEntries(
          (res.data || []).map(method => [method.code, method.name])
        )
        const originalOptions = this.dictMap['clinic_pay_channel'] || []
        const originalMap = new Map(
          originalOptions.map(option => [String(option.value), option])
        )
        this.dictMap['clinic_pay_channel'] = (res.data || [])
          .filter(method => method.status)
          .map(method => {
            const original = originalMap.get(method.code)
            return {
              value: method.code,
              label: method.name,
              colorType: original?.colorType || '',
              cssClass: original?.cssClass || '',
            }
          })
      } catch (error) {
        // 支付方式接口异常时保留系统字典，避免影响基础收费功能。
      }
    },
    async setAreaTree() {
      const res = await getAreaTree()
      this.areaTree = res.data ?? []
    },
  },
})

// export const useDictStoreWithOut = () => {
//   return useDictStore(store)
// }
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useDictStore, import.meta.hot))
}
